import React, { useState } from 'react';
import NavBar from './Navbar';
import ProductHub from './producthub';

export default function ProductUpdatesScreen() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [blog, setBlog] = useState(0);
  const [imageUrl, setImageUrl] = useState('');
  const [live, setLive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [author, setAuthor] = useState('');
  const [showProductHub, setShowProductHub] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const response = await fetch('https://api.insightos.co.uk/admin/productupdates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          Title:title,
          Content:content,
          Blog:parseInt(blog),
          ImageUrl:imageUrl,
          Live:parseInt(live),
          Author:author
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setSuccess('Product update submitted successfully!');
        // Reset form
        setTitle('');
        setContent('');
        setBlog(0);
        setImageUrl('');
        setLive(0);
      } else {
        setError(data.message || 'Failed to submit product update');
      }
    } catch (err) {
      setError('Error connecting to API');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <NavBar />
      <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 px-4">
        {/* Header - Centered */}
        <div className="max-w-lg w-full mx-auto pt-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-2xl font-bold text-white">Product Updates</h2>
            <button
              onClick={() => setShowProductHub(!showProductHub)}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition-colors duration-200"
            >
              {showProductHub ? 'Close Product Hub' : 'Open Product Hub'}
            </button>
          </div>
        </div>

        {/* Product Hub - Full Width */}
        {showProductHub ? (
          <div className="w-full">
            <ProductHub />
          </div>
        ) : (
          /* Form - Centered */
          <div className="max-w-lg w-full mx-auto">
            <div className="bg-white/10 backdrop-blur-lg rounded-lg shadow-xl p-8 border border-white/20">
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="title" className="block text-sm font-medium text-white mb-2">Title</label>
                  <input
                    id="title"
                    name="title"
                    type="text"
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white placeholder-gray-300 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter title..."
                    required
                  />
                </div>

                <div>
                  <label htmlFor="content" className="block text-sm font-medium text-white mb-2">Content</label>
                  <textarea
                    id="content"
                    name="content"
                    value={content}
                    onChange={e => setContent(e.target.value)}
                    rows={4}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white placeholder-gray-300 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter content..."
                    required
                  />
                </div>

                <div>
                  <label htmlFor="blog" className="block text-sm font-medium text-white mb-2">Blog (0 or 1)</label>
                  <select
                    id="blog"
                    name="blog"
                    value={blog}
                    onChange={e => setBlog(e.target.value)}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                  >
                    <option value={0}>0</option>
                    <option value={1}>1</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="imageUrl" className="block text-sm font-medium text-white mb-2">Image URL</label>
                  <input
                    id="imageUrl"
                    name="imageUrl"
                    type="url"
                    value={imageUrl}
                    onChange={e => setImageUrl(e.target.value)}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white placeholder-gray-300 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter image URL..."
                  />
                </div>

                <div>
                  <label htmlFor="live" className="block text-sm font-medium text-white mb-2">Live (0 or 1)</label>
                  <select
                    id="live"
                    name="live"
                    value={live}
                    onChange={e => setLive(e.target.value)}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                  >
                    <option value={0}>0</option>
                    <option value={1}>1</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="author" className="block text-sm font-medium text-white mb-2">Author</label>
                  <input
                    id="author"
                    name="author"
                    type="text"
                    value={author}
                    onChange={e => setAuthor(e.target.value)}
                    className="block w-full rounded-md border-0 bg-white/20 py-2 text-white placeholder-gray-300 shadow-sm ring-1 ring-inset ring-white/10 focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter author name..."
                  />
                </div>

                {error && <div className="bg-red-500/20 border border-red-500/50 text-red-100 px-4 py-3 rounded-md">{error}</div>}
                {success && <div className="bg-green-500/20 border border-green-500/50 text-green-100 px-4 py-3 rounded-md">{success}</div>}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 px-4 rounded-md bg-blue-600 text-white font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 transition-colors duration-200"
                >
                  {loading ? 'Submitting...' : 'Submit Product Update'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
